import { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BACKEND_URL } from "@/lib/backendUrl";

const API = `${BACKEND_URL}/api`;

export function useSettings() {
  const [settings, setSettings] = useState(null);
  const [effectMode, setEffectMode] = useState("fixed");

  const applyServer = (data) => {
    setSettings(data);
    setEffectMode(data.special_effect?.mode || "fixed");
  };

  const refresh = () => axios.get(`${API}/settings`).then(({ data }) => applyServer(data)).catch(() => toast.error("Could not load prices — check your connection"));

  useEffect(() => { refresh(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const effectiveSettings = useMemo(() => {
    if (!settings) return null;
    return { ...settings, special_effect: { ...settings.special_effect, mode: effectMode } };
  }, [settings, effectMode]);

  const saveSettings = async (draft) => {
    try {
      const { data } = await axios.put(`${API}/settings`, draft);
      applyServer(data);
      toast.success("Prices saved", { description: "价格已保存" });
    } catch (e) {
      if (e?.response?.status === 409) {
        await refresh();
        toast.error("Settings changed on another device", { description: "Reloaded the latest version — please re-apply your changes. 设置已在其他设备更改，请重新输入。" });
        throw e;
      }
      toast.error("Could not save settings");
      throw e;
    }
  };

  const resetSettings = async () => {
    const { data } = await axios.post(`${API}/settings/reset`);
    applyServer(data);
    toast.success("Default prices restored", { description: "Shop details and website content were kept. 已恢复默认价格" });
  };

  const changeEffectMode = async (mode) => {
    setEffectMode(mode);
    try {
      const { data: latest } = await axios.get(`${API}/settings`);
      const updated = { ...latest, special_effect: { ...latest.special_effect, mode } };
      const { data } = await axios.put(`${API}/settings`, updated);
      applyServer(data);
    } catch (e) {
      if (e?.response?.status === 409) return refresh().catch(() => {}); // another tab / rapid toggle won — reload the truth
      toast.error("Could not save Tricoat mode");
    }
  };

  return { settings, effectiveSettings, effectMode, sym: settings?.currency_symbol || "$", refresh, saveSettings, resetSettings, changeEffectMode };
}
